import { Directive, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppPages } from '@app/app.pages';
import { AuthService } from '@app/services/auth/auth.service';

@Directive({
  selector: '[appLogout]',
  standalone: true
})
export class LogoutDirective {

  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);

  @HostListener('click') async onClick() {
    await this.authService.logout();
    this.router.navigate([AppPages.LOGIN]);
  }

}
